import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'relativeTime' })
export class RelativeTimePipe implements PipeTransform {
    transform(value: string): string {

        let result: string;

        let date = new Date(Number(value));
        if (value && value.indexOf('T') > -1) {
            const d = Date.parse(value);
            date = new Date(Number(d));
        }

        const now = new Date().getTime();

        const delta = (now - date.getTime()) / 1000;

        if (delta < 60) {
            result = '刚刚';
        } else if (delta < 3600) { // 小于 1 小时
            result = Math.floor(delta / 60) + ' 分钟前';
        } else if (delta < 86400) { // 小于 1 天
            result = Math.floor(delta / 3600) + ' 小时前';
        } else if (delta < 2592000) { // 小于 30 天
            result = Math.floor(delta / 86400) + ' 天前';
        } else {
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            result = year + '-' + month + '-' + day;
        }

        return result;

    }
}
